<template>
    <div>
        <!-- Ряд 1: Тикеты -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <loading :status="stats.open_tickets == null"/>
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Open tickets') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.open_tickets != null ? stats.open_tickets : 0 }}
                    </dd>
                </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <loading :status="stats.pending_tickets == null"/>
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('In progress tickets') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.pending_tickets != null ? stats.pending_tickets : 0 }}
                    </dd>
                </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <loading :status="stats.solved_tickets == null"/>
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Closed tickets') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.solved_tickets != null ? stats.solved_tickets : 0 }}
                    </dd>
                </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <loading :status="stats.total_employees == null"/>
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Total employees') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.total_employees != null ? stats.total_employees : 0 }}
                    </dd>
                </div>
            </div>
        </div>
        <!-- Ряд 2: Дополнительная статистика -->
        <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4" v-if="stats.total_products != null">
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Total products') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.total_products }}
                    </dd>
                </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Total clients') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.total_clients }}
                    </dd>
                </div>
            </div>
            <div v-if="stats.total_partners != null" class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Total partners') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.total_partners }}
                    </dd>
                </div>
            </div>
            <div class="bg-white overflow-hidden shadow rounded-lg">
                <div class="px-4 py-5 sm:p-6">
                    <dt class="text-sm font-medium text-gray-500 truncate">
                        {{ $t('Total frontends') }}
                    </dt>
                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                        {{ stats.total_frontends }}
                    </dd>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "stats",
    data() {
        return {
            stats: {
                open_tickets: null,
                pending_tickets: null,
                solved_tickets: null,
                total_employees: null,
                total_products: null,
                total_clients: null,
                total_partners: null,
                total_frontends: null,
            }
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            const self = this;
            axios.get('api/dashboard/stats/count').then(function (response) {
                self.stats = response.data;
            });
        }
    },
}
</script>
